<style>
.echarts {
  width: 100%;
  height: 100%;
}

.active_table {
  width: 100%;
  height: 100%;
}

.ch {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding-top: 10vh;
}

.ch li {
  float: left;
}

.ch .cl {
  clear: both;
}
</style>

<template>
  <div class="active_table">
    <toolbar>
      <div class="search">
        <DatePicker type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px; margin-left: 10px"
          @on-change="dateSelect($event)"></DatePicker>
        <i-button type="default" @click="searchFunc" style="margin-left: 1em">搜索</i-button>
      </div>
    </toolbar>
    <div><v-chart autoresize :options="orgOptions" style="width: 95vw; height: 60vh;margin: 0 auto;" /></div>
  </div>
</template>
 
<script>
//import ECharts from "echarts";
//<v-chart theme="ovilia-green" :options="polar"/>
// :options="polar"
//import  theme  from './theme.json'
//ECharts.registerTheme('ovilia-green', theme); //引入主题

import toolbar from "../toolBar.vue"; // 操作栏组件

export default {
  data() {
    return {
      orgOptions: {},
      // 查询
      search: {
        startDate: null,
        endDate: null,
      },
    };
  },
  components: {
    toolbar,
  },
  created: function () {
    this.getData();
  },
  methods: {
    getData() {
      // 获取数据
      this.$api.BigData.getChart0({ content: this.search }, [
        "uuid",
        "company",
      ]).then((res) => {
        if (res.code == 0) {
          // 获取成功
          let warnData = res.data; //数据
          let dateList = []; // 标题
          let dataList = []; // 数据值
          //计算总秒数
          warnData.forEach((res) => {
            let cv = res.count;
            let jsd = {};
            jsd["value"] = cv;
            if (res.date.indexOf("告警") < 0) {
              dateList.push(res.date + "(" + cv + "%)");
              jsd["name"] = res.date + "(" + cv + "%)";
            } else {
              jsd["name"] = "告警区域比例";
            }
            dataList.push(jsd);
            //console.log(res.date);
          });

          this.orgOptions = {
            title: {
              text: "正常运行率",
              subtext: "动态数据",
              x: "center",
            },
            tooltip: {
              trigger: "item",
              formatter: "{a} <br/>{b} ",
            },
            toolbox: {
              show: true,
              feature: {
                saveAsImage: {},
              },
            },
            legend: {
              show: true,
              orient: "vertical",
              left: "left",
              data: dateList,
            },
            series: [
              {
                name: "正常运行率",
                type: "pie",
                radius: "55%",
                center: ["50%", "60%"],
                data: dataList,
                itemStyle: {
                  emphasis: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: "rgba(0, 0, 0, 0.5)",
                  },
                },
              },
            ],
          };
          this.$Message.success("加载完成");
        } else {
          this.$Message.warning(res.message);
        }
      });
    },
    // 选择时间
    dateSelect(date) {
      this.search.startDate = new Date(date[0]).setHours("0");
      this.search.endDate = new Date(date[1]).setHours("24");
      //console.log(this.search);
    },
    // 搜索
    searchFunc() {
      this.getData();
    },
  },
};
</script>